import { NgModule } from '@angular/core';

import { MaterialItemsModule } from '../../shared/material-items.module';
import { SharedModule } from '../../shared/shared.module';
import { MatMenuModule } from '@angular/material/menu';
import { DatePipe } from '@angular/common';
import {
  WcgButtonComponent,
  WcgDialogModule,
  WcgInputFieldComponent,
  WcgPaginationComponent,
} from '@wcg/frontend-framework';
import { PaginationShowPageDirective } from './ui/make-change-in-research/pagination-show-page.directive';
import { IrisCardModule } from '@shared/components/iris-card/iris-card.module';
import { MakeChangeEffects } from './data-access/effects/make-change.effects';
import { EffectsModule } from '@ngrx/effects';

@NgModule({
  declarations: [PaginationShowPageDirective],
  imports: [
    IrisCardModule,
    MatMenuModule,
    MaterialItemsModule,
    SharedModule,
    WcgButtonComponent,
    WcgDialogModule,
    WcgPaginationComponent,
    WcgInputFieldComponent,
    EffectsModule.forFeature([MakeChangeEffects]),
  ],
  providers: [DatePipe],
})
export class ERMWorkspaceModule {}
